import { render, staticRenderFns } from "./Textbox.vue?vue&type=template&id=088d4d24&scoped=true&"
import script from "./Textbox.vue?vue&type=script&lang=ts&"
export * from "./Textbox.vue?vue&type=script&lang=ts&"
import style0 from "./Textbox.vue?vue&type=style&index=0&id=088d4d24&lang=postcss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "088d4d24",
  null
  
)

export default component.exports